import CustomerDashboardLayout from "./default";
export default CustomerDashboardLayout;
